"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeWithID = exports.routeWithParams = exports.getDashboardLink = void 0;
const routes = {
    ROOT: '/',
    PLAYGROUND: '/playground/vYk7JTNxA7hF',
    BLOG: 'https://moben.com.br/blog',
    SIGNOUT: '/sair',
    ADMIN: '/admin/a7Hcd2jsEwS849xKSgEDXL',
    HOW_WORK: '/comofunciona',
    TEAM: '/equipe',
    TUTORIAL: '/tutorial',
    PRICING: '/quantocusta',
    TALK_TO_US: '/faleconosco',
    CONTACT: '/contato',
    PRIVACY_POLICIES: '/politicasdeprivacidade',
    FAQ: '/perguntas-frequentes',
    EXPERIMENTE: '/experimente',
    /** /:page - identifica a "pagina" especifica da confirmacao **/
    DEFAULT_CONFIRMATION: '/confirmacao',
    CALCULATOR_READJUST: '/calculadora/reajuste',
    SUBSCRIPTION_CANCEL: '/cancelarassinatura',
    CANCEL_CONFIRMATION: '/cancelarconfirmacao',
    RECEIPTS: '/comprovantes',
    TENANT: '/inquilino',
    SURVEY: '/vistoria',
    UNDER_CONSTRUCTION: '/emconstrucao',
    INTERESTED_ANALYSIS_CONFIRMATION: '/interessado-analise-confirmacao',
    DASHBOARD_DECISION: '/dashboard-escolha',
    DASHBOARD_CONTRACT_TENANT: '/dashboard/inquilino/contrato',
    DASHBOARD_TENANT_PAYMENT_LIST: '/dashboard/inquilino/boletos-status',
    DASHBOARD_ROOT: '/dashboard',
    DASHBOARD_INIT: '/dashboard/inicio',
    DASHBOARD_ROOT_TENANT: '/dashboard/inquilino',
    DASHBOARD_PROPERTY_LIST: '/dashboard/meus-imoveis',
    DASHBOARD_TENANT_PROPERTY_LIST: '/dashboard/inquilino/meus-imoveis',
    DASHBOARD_REPAIRS: '/dashboard/reparos',
    DASHBOARD_FOTOS: '/dashboard/fotos',
    DASHBOARD_DIVULGATION: '/dashboard/divulgacao',
    DASHBOARD_IRPF: '/dashboard/irpf',
    DASHBOARD_STATUS_RENT: '/dashboard/statusdoaluguel',
    DASHBOARD_BOLETOS: '/dashboard/boletos',
    DASHBOARD_BOLETO_FORM: '/dashboard/boleto-form',
    DASHBOARD_BOLETO_DETAIL: '/dashboard/boleto-detalhe',
    DASHBOARD_BOLETOS_STATUS: '/dashboard/boletos-status',
    DASHBOARD_CONTROL: '/dashboard/controle',
    DASHBOARD_CONTROL_STATUS: '/dashboard/controle-status',
    DASHBOARD_LEGAL: '/dashboard/juridico',
    DASHBOARD_RECEIPTS: '/dashboard/comprovantes',
    DASHBOARD_RECEIPTS_TYPE: '/dashboard/comprovantes-tipo-data',
    DASHBOARD_PROPOSALS_LIST: '/dashboard/propostas',
    /** :proposalId */
    DASHBOARD_CREDIT_ANALYSIS: '/dashboard/analise-credito',
    /** ?uid={PROPERTY_ID} | proposal={PROPOSAL_ID} */
    DASHBOARD_PROPOSALS_REGISTER: '/dashboard/interessado/novo',
    /** ?id={USER_ID} */
    DASHBOARD_PROPOSALS_EDIT: '/dashboard/interessado/editar',
    /** ?proposal={PROPOSAL_ID} */
    DASHBOARD_PROPOSALS_INVITE: '/dashboard/interessado/convidar',
    DASHBOARD_PROPOSALS_OPTIONS: '/dashboard/propostas-opcoes',
    DASHBOARD_CONTRACT_UPLOAD: '/dashboard/contrato-vigente',
    DASHBOARD_FIANCA_INSURANCE: '/dashboard/seguro/fianca',
    DASHBOARD_FIRE_INSURANCE: '/dashboard/seguro/incendio',
    DASHBOARD_AD_CREATE: '/dashboard/anuncio',
    DASHBOARD_BANK_STATMENT: '/dashboard/extrato',
    DASHBOARD_PAYMENTS_LIST_MONTH: '/dashboard/controle-financeiro',
    DASHBOARD_AD_LEADS: '/dashboard/anuncio-leads',
    DASHBOARD_RENEW: '/dashboard/renovacao',
    /** ?pid={PAYMENT_ID}&iid={PROPERTY_ID}&uid={USER_ID}[&did={DOCUMENT_ID}] */
    PAYMENT_MARK_AS_PAID: '/comprovante-pagamento',
    DASHBOARD_DOCUMENT_AREA: '/dashboard/documentos-e-comprovantes',
    DASHBOARD_TENANT_DOCUMENT_AREA: '/dashboard-inquilino/documentos-e-comprovantes',
    DASHBOARD_TENANT_ROOT: '/dashboard-inquilino',
    DASHBOARD_TENANT_ASK: '/dashboard-inquilino/duvidas',
    DASHBOARD_TENANT_PROPERTY: '/dashboard-inquilino/dados-imovel',
    DASHBOARD_TENANT_OWNER_PROFILE: '/dashboard-inquilino/proprietario',
    DASHBOARD_TENANT_RECEIPTS: '/dashboard-inquilino/comprovantes',
    DASHBOARD_TENANT_CONTRACT: '/dashboard-inquilino/contrato',
    DASHBOARD_TENANT_PAYMENTS: '/dashboard-inquilino/pagamentos',
    DASHBOARD_TENANT_ADDITIONAL_DOCUMENTS: '/dashboard-inquilino/documentos-adicionais',
    REGISTER_ROOT: '/cadastro',
    REGISTER_PROPERTY_NEW: '/cadastro/imovel',
    REGISTER_PROPERTY_EDIT: '/cadastro/imovel/editar',
    REGISTER_HELP: '/cadastro/precisodeajuda',
    /** @deprecated use SIGNUP_* instead */
    REGISTER_SIGNUP: '/cadastrar',
    /** @deprecated use SIGNUP_* instead */
    REGISTER_LOGIN: '/entrar',
    /** @deprecated use SIGNUP_* instead */
    REGISTER_VERIFICATION_CODE: '/verificacao-sms',
    SIGNUP_REGISTER_OPTIONS: '/cadastrar',
    SIGNUP_SIGNIN_OPTIONS: '/entrar',
    SIGNUP_SIGNIN_EMAIL: '/entrar/email',
    SIGNUP_REGISTER_EMAIL: '/cadastrar/email',
    SIGNUP_SIGNIN_PHONE: '/entrar/sms',
    SIGNUP_REGISTER_PHONE: '/cadastrar/sms',
    SIGNUP_VERIFICATION_CODE: '/verificacao-sms',
    SIGNUP_SIGNIN_MAIL_RECOVER: '/entrar/email/recuperar-senha',
    SIGNUP_RESET_PASS: '/entrar/email/nova-senha',
    FIREBASE_ACTION_DISPATCHER: '/action/dispatch',
    //MEUS DADOS
    MYDATA_ROOT: '/meus-dados',
    MYDATA_PROFILE: '/meus-dados/perfil',
    MYDATA_PROFILE_SECTION_CARDS: '/meus-dados/perfil#cartoes',
    MYDATA_PROFILE_SECTION_DARA: '/meus-dados/perfil#meus-dados',
    MYDATA_PROFILE_SECTION_BANK_STATMENT: '/meus-dados/perfil#extrato',
    MYDATA_PROFILE_ADD_CARD: '/meus-dados/novo-cartao',
    REGISTER_MYDATA_INCOME: '/meus-dados/renda',
    REGISTER_MYDATA_FINANCIAL_OBLIGATIONS: '/meus-dados/compromissos-financeiros',
    REGISTER_MYDATA_EXTRA_DATA: '/meus-dados/informacoes-adicionais',
    /** /:propertyId/:creditAnalysis/:proposalId **/
    REGISTER_TENANT_FIADOR: '/meus-dados/fiador',
    //CONVITE
    INVITE_ROOT: '/convite',
    /** /:inviteType/:propertyId/:creditAnalysis/:proposalId? **/
    REGISTER_INVITE_ENTRY: '/convite',
    // CONTRACT_ROOT: '/contrato',
    CONTRACT_ENTRY: '/contrato/inicio',
    CONTRACT_STEPS_LIST: '/contrato/etapas',
    CONTRACT_OWNER_DATA: '/contrato/dados-proprietario',
    CONTRACT_OWNER_ADDRESS: '/contrato/endereco-proprietario',
    CONTRACT_BANK_INFO: '/contrato/informacoes-bancarias',
    CONTRACT_PROPERTY: '/contrato/dados-imovel',
    CONTRACT_VALIDITY: '/contrato/vigencia',
    CONTRACT_RENTDUE: '/contrato/vencimento-aluguel',
    CONTRACT_RENTFEES: '/contrato/valores',
    CONTRACT_RENTFEES_IPTU: '/contrato/iptu',
    CONTRACT_FIRE_INSURANCE: '/contrato/seguro-incendio',
    CONTRACT_SUMMARY: '/contrato/resumo',
    CONTRACT_PENALTIES: '/contrato/multas',
    CONTRACT_TENANT: '/contrato/dados-inquilino',
    CONTRACT_GUARANTEES: '/contrato/garantia',
    CONTRACT_SURVEY: '/contrato/vistoria',
    CONTRACT_FORO: '/contrato/foro',
    CONTRACT_READJUSTMENT_INDEX: '/contrato/indice-de-reajuste',
    CONTRACT_WITNESSES: '/contrato/testemunhas',
    CONTRACT_EXTRA_INFO: '/contrato/assinatura',
    CONTRACT_CREATED: '/contrato/opcoes',
    /** /:renewOption - renovar | nao-alterar | encerrar **/
    CONTRACT_RENEW: '/contrato/renovacao',
    CONTRACT_RENEW_REDO: '/contrato/renovacao/renovar',
    CONTRACT_RENEW_NONE: '/contrato/renovacao/nao-alterar',
    CONTRACT_RENEW_FINISH: '/contrato/renovacao/encerrar',
    CONTRACT_APPROVAL: '/contrato/aprovar',
    CONTRACT_APPROVAL_OBSERVATION: '/contrato/aprovacao/adicionar-observacoes',
    CONTRACT_APPROVAL_SUMMARY: '/contrato/aprovacao/sumario',
    CONTRACT_APPROVAL_DONE: '/contrato/aprovacao/aprovado',
    /** /:encodedParams = base64 encoded com um objeto nesse formato {"property":"UID","payment":"ID"} **/
    PAYMENT_VIEW: '/pagamento/visualizar',
};
exports.getDashboardLink = (user) => {
    if (user) {
        if ((user === null || user === void 0 ? void 0 : user.is_owner) && ((user === null || user === void 0 ? void 0 : user.is_tenant) || (user === null || user === void 0 ? void 0 : user.is_fiador))) {
            return routes.DASHBOARD_DECISION;
        }
        if (user === null || user === void 0 ? void 0 : user.is_tenant) {
            return exports.routeWithID(routes.DASHBOARD_TENANT_ROOT, user.tenant_of.id);
        }
        if (user === null || user === void 0 ? void 0 : user.is_fiador) {
            return exports.routeWithID(routes.DASHBOARD_TENANT_ROOT, user.fiador_of.id);
        }
    }
    return routes.DASHBOARD_ROOT;
};
/**
 * Funciona com base no arguments, logo o uso seria algo como `routeWithParams('rota', 'parametro1', 'parametro2', ...)`
 *
 * @param {string} route
 * @return {string}
 */
exports.routeWithParams = function (route, ...args) {
    const paths = [route, ...args];
    return paths.join('/');
};
exports.routeWithID = (route, id) => `${route}?id=${id}`;
exports.default = routes;
//# sourceMappingURL=index.js.map